import {
  faUser,
  faUserCircle,
  faEnvelope,
  faLock,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import createField from "../../utils/factory/createField";
import SelectableDialog from "../../components/SelectableDialog";

export const userProfileFields = [
  {
    section: "Dados do Usuário",
    fields: [
      createField({
        id: "name",
        label: "Nome",
        type: "text",
        placeholder: "Digite o nome do usuário",
        icon: faUser,
      }),
      createField({
        id: "username",
        label: "Usuário",
        type: "text",
        placeholder: "Digite o nome de usuário",
        icon: faUserCircle,
      }),
      createField({
        id: "email",
        label: "E-mail",
        type: "email",
        placeholder: "Digite o e-mail",
        icon: faEnvelope,
        fullWidth: true,
      }),
      createField({
        id: "password",
        label: "Senha",
        type: "password",
        placeholder: "Digite uma nova senha",
        icon: faLock,
      }),
      createField({
        id: "password_confirmation",
        label: "Confirmar Senha",
        type: "password",
        placeholder: "Confirme a nova senha",
        icon: faLock,
      }),
    ],
  },
];

export const userPermissionsFields = [
  {
    section: "Permissões",
    fields: [
      createField({
        id: "roles",
        label: "Cargos",
        type: "select",
        placeholder: "Selecione os cargos",
        icon: faUser,
        isMulti: true,
        fullWidth: true,
      }),
    ],
  },
];
